/**
 * Returns an array of an object's own enumerable property values.
 * Alias for Object.values providing a more functional API.
 *
 * @param obj - Object to extract values from
 * @returns Array of property values
 *
 * @example
 * ```ts
 * import { Values } from "@pdfking/tfunc"
 *
 * const obj = { name: "John", age: 30 }
 * const values = Values(obj) // ["John", 30]
 *
 * values.forEach(value => {
 *   console.log(value)
 * })
 * ```
 */
export const Values = Object.values
